import { EMPTY_LIST, EMPTY_STRING } from '../../../../constants/common'
import { getListingUnitLabel } from '../../../RentalPortalListing'
import { LISTING_VIEWING_ROW_ACTIONS } from '../../../RentalPortalViewing'

export function getIsApplicantViewingsEmpty({ isInitiated, viewings }) {
  const hasViewings = viewings?.length > 0

  return isInitiated && !hasViewings
}

export function getApplicantViewingListingLabel({ item, t }) {
  return getListingUnitLabel({ listing: item, t }) ?? EMPTY_STRING
}

export function getApplicantViewingItemActions(viewing) {
  return viewing?.permissions?.can_view
    ? LISTING_VIEWING_ROW_ACTIONS
    : EMPTY_LIST
}
